import { observer } from 'mobx-react';
import React from 'react';
import itemsStore from '../../store/itemsStore';
import { IProductV4Exclusion } from 'src/types/product';
import { getTranslate } from 'src/utils/helpers';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import './style.scss';

interface IProps {
  exclusion: IProductV4Exclusion;
}

const ItemExclusion: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  return (
    <li className="item-exclusion">
      <p className="family-semibold text-size-20 color-dark">{getTranslate(props.exclusion.name)}</p>
      <DeleteRestoreBlock iconSize={20} iconClassName="color-dark" onDelete={() => itemsStore.changeExclusions(props.exclusion.id)} />
    </li>
  );
});

export default ItemExclusion;
